var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("CompensatoryServiceHistory", {
    attrs: {
      "get-compensatory-request-student-service":
        _vm.getCompensatoryRequestStudentService,
      "get-status-history": _vm.getStatusHistory,
      "request-service-data": _vm.serviceData
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }